<script setup>
const props = defineProps({
  customSuccessTxt: {
    type: String,
    default: () => 'Dziękujemy za zainteresowanie naszą ofertą. Skontaktujemy się z Tobą niebawem.'
  },
  isLiczakOffer:{
    type: Boolean,
    default: false,
    required: false,
  }
})
let currentState = "";

const state = ref("");
const animateState = ref([]);
const visibleState = ref([]);

const emit = defineEmits(['close'])

const animateOut = () => {
  return new Promise(resolve => {
    if (currentState === "") {
      resolve();
      return;
    }
    animateState.value[currentState] = false;
    setTimeout(() => {
      visibleState.value[currentState] = false;
      resolve();
    }, 200);
  })
}

const animateIn = () => {
  return new Promise(resolve => {
    visibleState.value[currentState] = true;
    setTimeout(() => {
      animateState.value[currentState] = true;
      resolve();
    }, 50);
  })
}

const setBusy = () => state.value = 'busy';
const setFailure = () => state.value = 'failure';
const setSuccess = () => state.value = 'success';
const setNone = () => {
  state.value = '';
  emit('close')
}

defineExpose({
  setBusy,
  setFailure,
  setSuccess,
  setNone
})

watch(() => state.value,
  async (newState) => {
    if (currentState === newState) return;
    await animateOut();
    currentState = newState;
    animateIn();
  }
)

const route = useRoute();
const isCalculatorPage = computed(() => route.name === "kalkulator-leasingowy")
</script>


<template>
  <div class="hidden absolute inset-0 z-20 opacity-0 justify-center items-center transition-opacity overflow-hidden"
       :class="{'!flex': visibleState['busy'], 'opacity-100': animateState['busy'], 'bg-[#e9e9e9]/95 dark:bg-gray-700/95': isCalculatorPage, 'bg-white/80': !isCalculatorPage, 'rounded-2xl mt-2 mb-2  lg:mt-4 lg:mb-4': isLiczakOffer}">
    <div class="flex items-center">
      <EffectLoader class="self-center" />
    </div>
  </div>
  <div class="hidden absolute rounded inset-0  z-20 opacity-0 justify-center items-center transition-opacity"
       :class="{'!flex': visibleState['success'], 'opacity-100': animateState['success'], 'bg-[#e9e9e9]/95 dark:bg-gray-700/95': isCalculatorPage, 'bg-gray-300/80': !isCalculatorPage}">

    <div class="py-6 px-6 flex flex-col justify-center items-center gap-6 w-full"
      :class="isCalculatorPage ? 'bg-[#e9e9e9]/95 dark:bg-gray-700/95' : 'bg-white'"
    >
      <div class="text-celadon font-light text-xl">Sukces!</div>
      <div class="font-extralight text-center" :class="isCalculatorPage && 'dark:text-white'" v-html="props.customSuccessTxt"></div>
      <ButtonRounded color="transparent" class="w-full !border-celadon !text-celadon max-w-64" @click="setNone">OK</ButtonRounded>
    </div>
  </div>

  <div class="hidden absolute rounded inset-0 z-20 opacity-0 justify-center items-center transition-opacity"
       :class="{'!flex': visibleState['failure'], 'opacity-100': animateState['failure'], 'bg-[#e9e9e9]/95 dark:bg-gray-700/95': isCalculatorPage, 'bg-gray-300/80': !isCalculatorPage}">
    <div 
      class="py-6 px-6 flex flex-col justify-center items-center gap-6 w-full"
      :class="isCalculatorPage ? 'bg-[#e9e9e9]/95 dark:bg-gray-700/95' : 'bg-white'"
    >
      <div class="text-error-red font-light text-xl">Błąd!</div>
      <div class="font-extralight text-center" :class="isCalculatorPage && 'dark:text-white'">Formularz nie został wysłany poprawnie. Prosimy, spróbuj jeszcze raz.</div>
      <ButtonRounded color="transparent" class="w-full !border-error-red !text-error-red max-w-64" @click="setNone">OK</ButtonRounded>
    </div>
  </div>
</template>
